
import styled from 'styled-components';
import { Container } from '../Container/Container';

export const LogInCard = styled(Container)`
    border: 1px red solid;
    flex-direction: column;
    width: 35%;
    align-content: center;
    justify-content: center;
    border: 2px solid #dfdfdf;
    padding: 20px 0px 30px 0px;
`
export const InputWrapper = styled(Container)`
      flex-direction: row;
      margin-bottom: 5px;  
`